import type { QueryKeyFactory } from "app/pages/sales-intelligence/types/queries";

import { SALESLOFT_CADENCE_VISIBILITY, type SalesloftCadenceVisibility } from "../constants/salesloftConstants";

const BASE_KEY = "salesloft";
const CADENCES_QUERY_KEY = "cadences";

type CadencesQueryKeyParams = {
    name?: string;
    visibility?: SalesloftCadenceVisibility;
};

export const salesloftQueryKeys = {
    cadences: ({ name = "", visibility = SALESLOFT_CADENCE_VISIBILITY.all }: CadencesQueryKeyParams = {}) =>
        [BASE_KEY, CADENCES_QUERY_KEY, { name, visibility }] as const,
} as const satisfies QueryKeyFactory;
